const data = {
  currentIssueCover: '//www.fastcompany.com/magazine/latest-cover.jpg',
  magazineLink: 'https://www.fastcompany.com/magazine/',
  subscribeLink:
    'https://www.fastcompany.com/subscribe?cid=dan904:701:000:SCTA_&utm_source=paidDisplayOn&utm_medium=edit%20top%20nav&utm_campaign=dan904:701:000:SCTA_',
  cosites: [
    {
      siteTitle: 'FastCoDesign',
      siteLogo:
        '//a.fastcompany.net/image/upload/v1488299643/fc/CO.DESIGN_BURGER_LOCKUP.svg',
      siteURL: '//www.fastcodesign.com'
    },
    {
      siteTitle: 'FastCoStudios',
      siteLogo:
        '//a.fastcompany.net/image/upload/v1488300562/fc/video_burger.svg',
      siteURL: '//www.fastcompany.com/videos'
    }
  ],
  social: {
    fastcompany: [
      {
        property: 'facebook',
        url: 'https://www.facebook.com/FastCompany/',
        image:
          'https://images.fastcompany.net/image/upload/v1540911625/fcweb/fb-icon-cccccc-2x_anjwvt.svg',
        image_menu:
          'https://images.fastcompany.com/image/upload/v1576118408/fb-icon-circle-fb.svg'
      },
      {
        property: 'twitter',
        url: 'https://twitter.com/fastcompany',
        image:
          'https://images.fastcompany.net/image/upload/v1540911625/fcweb/tw-icon-cccccc-2x_xgkf9v.svg',
        image_menu:
          'https://images.fastcompany.com/image/upload/v1576118408/tw-icon-circle-tw.svg'
      },
      {
        property: 'instagram',
        url: 'https://www.instagram.com/fastcompany/',
        image:
          'https://images.fastcompany.net/image/upload/v1540911625/fcweb/insta-icon-cccccc-2x_qsacmj.svg',
        image_menu:
          'https://images.fastcompany.com/image/upload/v1576118408/insta-icon-circle-in.svg'
      },
      {
        property: 'linkedin',
        url: 'https://www.linkedin.com/company/fast-company',
        image:
          'https://images.fastcompany.net/image/upload/v1540911626/fcweb/linkedin-icon-cccccc-2x_ceogdj.svg',
        image_menu:
          'https://images.fastcompany.com/image/upload/v1576118408/linkedin-icon-circle-li.svg'
      },
      {
        property: 'youtube',
        url: 'https://www.youtube.com/user/FastCompany'
      }
    ]
  },
  collections: [
    {
      title: 'collections',
      className: 'main-menu__collections',
      isOpen: false,
      sections: [
        {
          title: 'Fast Government',
          url: 'https://www.fastcompany.com/section/fast-government',
          deck:
            'The future of innovation and technology in government for the greater good'
        },
        {
          title: 'Most Innovative Companies',
          url:
            'https://www.fastcompany.com/90603436/the-worlds-most-innovative-companies-2021',
          deck: 'Our annual guide to the businesses that matter the most'
        },
        {
          title: 'Most Creative People',
          url: 'https://www.fastcompany.com/most-creative-people/2021',
          deck:
            'Leaders who are shaping the future of business in creative ways'
        },
        {
          title: 'World Changing Ideas',
          url: 'https://www.fastcompany.com/section/world-changing-ideas',
          deck:
            'New workplaces, new food sources, new medicine--even an entirely new economic system'
        },
        {
          title: 'Innovation By Design',
          url: 'https://www.fastcompany.com/innovation-by-design/2021',
          deck: 'Celebrating the best ideas in business'
        }
      ]
    }
  ],
  fastcoworks: [
    {
      title: 'fastco works',
      className: 'main-menu__collections',
      isOpen: false,
      sections: [
        {
          title: 'AWS',
          url: 'https://www.fastcompany.com/fcw/aws'
        },
        {
          title: 'Boston Scientific',
          url: 'https://www.fastcompany.com/fcw/boston_scientific'
        },
        {
          title: 'Deloitte',
          url: 'https://www.fastcompany.com/fcw/deloitte',
          deck: ''
        },
        {
          title: 'Dept',
          url: 'https://www.fastcompany.com/fcw/dept',
          deck: ''
        },
        {
          title: 'Elevate Prize',
          url: 'https://www.fastcompany.com/fcw/elevate_prize',
          deck: ''
        },
        {
          title: 'Genpact',
          url: 'https://www.fastcompany.com/fcw/genpact',
          deck: ''
        },
        {
          title: 'Klarna',
          url: 'https://www.fastcompany.com/fcw/klarna',
          deck: ''
        },
        {
          title: 'Logitech',
          url: 'https://www.fastcompany.com/fcw/logitech',
          deck: ''
        },
        {
          title: 'Square',
          url: 'https://www.fastcompany.com/fcw/square',
          deck: ''
        },
        {
          title: 'Verizon AWS',
          url: 'https://www.fastcompany.com/fcw/verizon_and_aws',
          deck: ''
        },
        {
          title: 'Visa',
          url: 'https://www.fastcompany.com/fcw/visa',
          deck: ''
        },
        {
          title: 'FastCo Works',
          url: 'https://www.fastcompany.com/user/fastco-works',
          deck:
            "An award-winning team of journalists, designers, and videographers who tell brand stories through Fast Company's distinctive lens"
        }
      ]
    }
  ]
};

export default data;
